import { create } from "zustand";
import { IUserFacebook } from "@/types/user.types";
import selectColorFacebook from "@/components/common/selectColorFacebook";

export const useUserFacebook = create<IUserFacebook>((set) => ({
  data: {
    dynamic: "1",
    name: "",
    hide_the_numbers: "0",
    url: "",
    company: "",
    title: "",
    web_site: "",
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    welcome_screen: "",
    welcome_path: "",
    design_colors_primary: selectColorFacebook[0].color,
    design_colors_button: selectColorFacebook[0].buttonColor,
  },
  config: {},
  setUserFacebook: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  destroyUserFacebook: () => {
    set(() => {
      return {
        data: {
          dynamic: "1",
          name: "",
          hide_the_numbers: "0",
          url: "",
          company: "",
          title: "",
          web_site: "",
          image: "",
          image_name: "",
          image_type: "",
          image_path: "",
          welcome_screen: "",
          welcome_path: "",

          design_colors_primary: selectColorFacebook[0].color,
          design_colors_button: selectColorFacebook[0].buttonColor,
        },
        config: {},
      };
    });
  },
}));
